import React from 'react'
import NavBarHomeDark from '../../components/NavBar/NavBarHomeDark'
import Footer from '../../components/Footer/Footer'
import MainContent from './MainContent'
import NavBarHome from '../../components/NavBar/NavBarHome'

function Error404() {
  return (
    <div className="pt-[92px] flex flex-col min-h-screen">
      <NavBarHome />

      <section className="mb-16 mt-10">
        <MainContent />
      </section>

      <section>
        <Footer
          logo={"/Logo NextMaker.png"}
          bgColor="bg-dark-1"
          textColor="text-gray-100"
          borderColor="border-gray-400/20"
        />
      </section>
    </div>
  )
}

export default Error404